import { SelectOption } from '@fleet-beat/core';

export enum VehicleOwnershipEnum {
  Company = 'company-owned',
  Driver = 'driver-owned',
  RentByCompany = 'rented-by-company',
  RentByDriver = 'rented-by-driver',
}

export const VehicleOwnershipsOptions: SelectOption[] = [
  { value: VehicleOwnershipEnum.Company, label: 'Company' },
  { value: VehicleOwnershipEnum.Driver, label: 'Driver' },
  { value: VehicleOwnershipEnum.RentByCompany, label: 'Rent by Company' },
  { value: VehicleOwnershipEnum.RentByDriver, label: 'Rent by Driver' },
];
